import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { Target, Eye, ArrowRight } from "lucide-react";
import { WHY_CHOOSE, GALLERY } from "@/data/catalog";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        overline="Who We Are"
        title="Delivering complete packaging solutions under one roof."
        subtitle="ElitzPacks is a trusted manufacturer and supplier of high-quality packaging materials for eCommerce, retail, food, logistics, gifting, industrial and manufacturing businesses across India."
      />

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10">
        <Reveal>
          <div className="overflow-hidden rounded-4xl border border-border">
            <img src={GALLERY[0]} alt="ElitzPacks facility" className="w-full aspect-[16/7] object-cover" />
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 grid lg:grid-cols-2 gap-6">
        {[
          { Icon: Target, t: "Our Mission", d: "Deliver high-quality packaging that enhances product safety and strengthens brand identity — combining manufacturing expertise with a dependable supplier network." },
          { Icon: Eye, t: "Our Vision", d: "To become India's most trusted packaging partner, known for quality, customization, competitive pricing and reliable, customer-first service." },
        ].map((c, i) => (
          <Reveal key={c.t} delay={i * 0.1}>
            <div className="h-full rounded-3xl border border-border bg-card p-10">
              <span className="grid place-items-center h-14 w-14 rounded-2xl bg-secondary text-royal"><c.Icon size={26} /></span>
              <h2 className="mt-6 font-heading text-2xl font-bold text-foreground">{c.t}</h2>
              <p className="mt-3 text-muted-foreground leading-relaxed">{c.d}</p>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16">
        <Reveal><span className="overline text-royal">The ElitzPacks Advantage</span></Reveal>
        <Reveal delay={0.1}><h2 className="mt-4 font-heading text-3xl lg:text-4xl font-extrabold text-foreground mb-10">Why businesses choose us.</h2></Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_CHOOSE.map((w, i) => (
            <Reveal key={w.title} delay={(i % 3) * 0.06}>
              <div className="rounded-2xl border border-border p-6 h-full">
                <h3 className="font-heading font-bold text-foreground">{w.title}</h3>
                <p className="mt-1.5 text-sm text-muted-foreground">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10">
        <div className="rounded-4xl bg-navy text-white p-10 lg:p-16 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <h2 className="font-heading text-3xl lg:text-4xl font-extrabold max-w-lg">Ready to partner with ElitzPacks?</h2>
          <Link to="/request-quote" className="inline-flex items-center gap-2 rounded-full bg-white text-navy px-7 py-3.5 font-semibold hover:bg-emerald hover:text-white transition-colors w-fit">Request a Quote <ArrowRight size={18} /></Link>
        </div>
      </section>
    </div>
  );
}
